var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticStyle:{"color":"#222876"}},[_vm._v("\n  "+_vm._s(_vm.updateTime())+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }